var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantitativeReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 1.5C7.53974 1.5 7.16665 1.8731 7.16665 2.33333L7.16665 11.6667C7.16665 12.1269 7.53974 12.5 7.99998 12.5C8.46022 12.5 8.83331 12.1269 8.83331 11.6667L8.83331 2.33333C8.83331 1.8731 8.46022 1.5 7.99998 1.5ZM6.16665 2.33333C6.16665 1.32081 6.98746 0.5 7.99998 0.5C9.0125 0.5 9.83331 1.32081 9.83331 2.33333V11.6667C9.83331 12.6792 9.0125 13.5 7.99998 13.5C6.98746 13.5 6.16665 12.6792 6.16665 11.6667L6.16665 2.33333ZM13.3333 4.83333C12.8731 4.83333 12.5 5.20643 12.5 5.66667V11.6667C12.5 12.1269 12.8731 12.5 13.3333 12.5C13.7936 12.5 14.1666 12.1269 14.1666 11.6667V5.66667C14.1666 5.20643 13.7936 4.83333 13.3333 4.83333ZM11.5 5.66667C11.5 4.65414 12.3208 3.83333 13.3333 3.83333C14.3458 3.83333 15.1666 4.65414 15.1666 5.66667V11.6667C15.1666 12.6792 14.3458 13.5 13.3333 13.5C12.3208 13.5 11.5 12.6792 11.5 11.6667V5.66667ZM2.66665 7.5C2.20641 7.5 1.83331 7.8731 1.83331 8.33333L1.83331 11.6667C1.83331 12.1269 2.20641 12.5 2.66665 12.5C3.12688 12.5 3.49998 12.1269 3.49998 11.6667L3.49998 8.33333C3.49998 7.8731 3.12688 7.5 2.66665 7.5ZM0.833313 8.33333C0.833313 7.32081 1.65412 6.5 2.66665 6.5C3.67917 6.5 4.49998 7.32081 4.49998 8.33333L4.49998 11.6667C4.49998 12.6792 3.67917 13.5 2.66665 13.5C1.65412 13.5 0.833313 12.6792 0.833313 11.6667L0.833313 8.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantitativeReport);
export default __webpack_public_path__ + "static/media/quantitative-report.c05aec855fd687f8df48825587c45fff.svg";
export { ForwardRef as ReactComponent };